import { stepTypes } from './enums';
import { generalEnums } from '../../../../utils/enums';
import { responsiveSizeTimesheet } from '../../../../utils/constants';

export const timesheetSteps = [stepTypes.CLIENT, stepTypes.DATE, stepTypes.HOURS];

export const expenseSteps = [stepTypes.CLIENT, stepTypes.CURRENCY, stepTypes.EXPENSE];

export const getValidationMessage = (t, step, type, timesheetData, expenseData, isNoReceiptChecked, size) => {
  switch (step) {
    case 0:
      if (type === generalEnums.EXPENSE && !expenseData.ClaimDescription) {
        return t('dashboard.createclaim.validations.selectclaimdescription');
      }
      if (!timesheetData.ClientName) {
        return t('dashboard.createtimesheet.validations.selectclient');
      }
      if (!timesheetData.PlacementId || !timesheetData.PoNumber) {
        return t('dashboard.createtimesheet.validations.selectjobtitle');
      }
      break;
    case 1:
      if (type === generalEnums.EXPENSE && !expenseData.Comment) {
        return t('dashboard.createclaim.validations.comment');
      }
      if (type === generalEnums.EXPENSE && !expenseData.attachments.length && !isNoReceiptChecked) {
        return t('dashboard.createclaim.validations.upload');
      }
      break;
    case 2:
      if (type === generalEnums.EXPENSE && !expenseData.ExpenseAmount) {
        return t('dashboard.createclaim.validations.amount');
      }
      if (!timesheetData.TimesheetDetails[0].Location && size.width < responsiveSizeTimesheet) {
        return t('dashboard.createtimesheet.validations.enterlocation');
      }
      if (!timesheetData.TimesheetDetails[0].WorkTypeId && size.width < responsiveSizeTimesheet) {
        return t('dashboard.createtimesheet.validations.enterworktype');
      }
      break;
    default:
      return '';
  }

  return false;
};

export const getDisableRule = (step, type, data, expenseData, isNoReceiptChecked, currencyValue, amount, fxRate) => {
  switch (step) {
    case 0:
      if (
        type === generalEnums.EXPENSE &&
        expenseData.ClientName &&
        expenseData.JobTitle &&
        expenseData.ClaimDescription
      ) {
        return false;
      }

      if (type === generalEnums.TIMESHEET && data.ClientName && data.PlacementId) {
        return false;
      }
      break;
    case 1:
      if (type === generalEnums.TIMESHEET && data.TimesheetDetails[0].TimesheetHoursByDates?.length) {
        return false;
      }
      if (
        type === generalEnums.EXPENSE &&
        expenseData.CategoryId &&
        expenseData.Date &&
        expenseData.Comment &&
        (expenseData.attachments?.length || isNoReceiptChecked)
      ) {
        return false;
      }
      break;
    case 2:
      if (type === generalEnums.EXPENSE) {
        if (expenseData.ExpenseAmount > 0 && expenseData?.PayCurrency === currencyValue) {
          return false;
        }
        if (amount > 0 && fxRate > 0) {
          return false;
        }
      } else if (
        type === generalEnums.TIMESHEET &&
        data?.TimesheetDetails[0]?.WorkTypeId &&
        data?.TimesheetDetails[0]?.Location
      ) {
        return false;
      }
      break;
    default:
      return true;
  }

  return true;
};
